module.exports = __webpack_public_path__ + "img/purple-delete-icon.ae3563f8.svg";